import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

import { AuthenicationService } from '../../../_services/authenication.service';
import {environment} from '../../../../environments/environment';


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  userdetaild: string;
  baseUrl: string = environment.baseUrl;
  imgKey: string = environment.imgKey;
  encodedKey: string;

  constructor(private router: Router, private route: ActivatedRoute, private authenicationService: AuthenicationService) { }




  ngOnInit() {
    this.encodedKey = btoa(this.imgKey);
    this.userdetaild = this.authenicationService.userDetails();
    // console.log(this.userdetaild);
  }


  logout() {
    this.authenicationService.logout();
    this.router.navigateByUrl('/login');
    // location.reload();
  }
}
